import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";
import api from "../../utils/api";
import { clearCachedItem, getQueryParams } from "../../helpers";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";

const MATERIALS = "/materials";
const TREES = "/trees";

const getMaterialData = () => api.get(`${MATERIALS}/all`);
export const useGetMaterialData = (enabled = true) => {
  return useQuery([MATERIALS], getMaterialData, {
    keepPreviousData: true,
    enabled,
  });
};

const getAllMaterialData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${MATERIALS}?${queryString}`);
};
export const useGetAllMaterialData = () => {
  const queryProps = getQueryParams({ prefix: "material" });
  return useQuery([MATERIALS, queryProps], getAllMaterialData, {
    keepPreviousData: true,
  });
};

const getMaterialCost = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${MATERIALS}/cost?${queryString}`);
};
export const useGetMaterialCost = ({ customerId, materialId }) => {
  const queryProps = { customerId, materialId };
  return useQuery([MATERIALS, queryProps, "/cost"], getMaterialCost, {
    enabled: !!customerId && !!materialId,
  });
};

const getAllTreeData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${TREES}?${queryString}`);
};

export const useGetAllTreeData = () => {
  const queryProps = getQueryParams({ prefix: "tree" });
  return useQuery([TREES, queryProps], getAllTreeData, {
    retry: false,
    keepPreviousData: true,
  });
};

const postCreateMaterial = (payload) => api.post(MATERIALS, payload);
export const usePostCreateMaterial = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateMaterial, {
    onSuccess: () => {
      invalidate(queryClient, MATERIALS);
      invalidate(queryClient, TREES);
      clearCachedItem("materials");
      addSnackbarSuccess({ message: "Successfully Created Material" });
    },
  });
};

const getMaterialDetails = ({ queryKey }) =>
  api.get(`${MATERIALS}/${queryKey[1]}`);
export const useGetMaterialDetails = (id) =>
  useQuery([MATERIALS, id], getMaterialDetails, { enabled: !!id });

const putMaterial = ({ id, ...data }) => api.put(`${MATERIALS}/${id}`, data);
export const usePutMaterial = () => {
  const { addSnackbarSuccess, addSnackbarError } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putMaterial, {
    onSuccess: () => {
      invalidate(queryClient, MATERIALS);
      addSnackbarSuccess({ message: "Material updated" });
    },
    onError: (error) => addSnackbarError({ error }),
  });
};

const deleteMaterial = (id) => api.delete(`${MATERIALS}/${id}`);
export const useDeleteMaterial = () => {
  const { addSnackbarSuccess, addSnackbarError } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(deleteMaterial, {
    onSuccess: () => {
      invalidate(queryClient, MATERIALS);
      addSnackbarSuccess({ message: "Material deleted" });
    },
    onError: (error) => addSnackbarError({ error }),
  });
};
